import React from "react";
import { Box, Text, ListItem } from "@vinomofo/components";
import { Link } from "../link";
import { WhiskymofoLogo } from "../footer/WhiskymofoLogo";
import UnlockAccessCTA from "./UnlockAccessCTA";
import styled from "styled-components";
import { isWhiskymofoSignupPage } from "../../utils/is-page";
import { useLocation } from "@reach/router";

const FooterContainer = styled(Box)`
  background-color: #000;
  color: #fff;
  padding: 40px 20px;
`;

const NavContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 50px;
  width: 100%;
  padding-bottom: 20px;

  @media ${({ theme }) => theme.mq.max.mobile} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0;
    margin-bottom: 30px;
    order: 1;
  }
`;

const NavLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  text-align: center;

  &:hover {
    color: ${({ theme }) => theme.colors.liquidGold};
  }

  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 15px;
    padding: 12px 0;
  }
`;

const LegalContainer = styled(Box)`
  font-family: ${({ theme }) => theme.fonts.heading};
  text-align: center;
  max-width: 600px;
  font-size: 11px;
  color: #7a7a7a;
  text-transform: uppercase;
  line-height: 1.6;
`;

const WarningText = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 13px;
  color: #7a7a7a;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

const LegalList = styled(Box)`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const LegalListItem = styled(ListItem)`
  margin-bottom: 8px;
  display: block;
`;

const navItems = [
  { label: "All Spirits", to: "/spirits" },
  { label: "Scotch", to: "/spirits/scotch" },
  { label: "Bourbon", to: "/spirits/bourbon" },
  { label: "Japanese", to: "/spirits/japanese" },
  { label: "Gin", to: "/spirits/gin" },
  { label: "Rum", to: "/spirits/rum" },
];

export const WhiskymofoOneColumnFooter: React.FC = () => {
  const location = useLocation();
  return (
    <FooterContainer as="footer">
      {/* <NavContainer>
        {navItems.map((item) => (
          <NavLink key={item.label} to={item.to}>
            {item.label}
          </NavLink>
        ))}
      </NavContainer> */}
      {/* 50 px spacing = delete me when enabling the footer navigation */}
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        minHeight="50px"
      ></Box>

      <Box display="flex" flexDirection="column" alignItems="center">
        <WhiskymofoLogo />
        {isWhiskymofoSignupPage(location.pathname) && <UnlockAccessCTA />}
        <LegalContainer>
          <WarningText>Warning:</WarningText>
          <LegalList as="ul">
            <LegalListItem as="li">
              Under the Liquor Licensing Act 1990 it is an offence:
            </LegalListItem>
            <LegalListItem as="li">
              • For liquor to be delivered to a person under the age of 18
              years.
              <br />
              Penalty: Fine not exceeding 20 penalty units
            </LegalListItem>
            <LegalListItem as="li">
              • For a person under the age of 18 years to purchase liquor.
              <br />
              Penalty: Fine not exceeding 10 penalty units
            </LegalListItem>
          </LegalList>
        </LegalContainer>
      </Box>
    </FooterContainer>
  );
};
